import { ADMIN_MAIN_ROUTE } from '../../constants/admin.routing.constants';
import { AUTH_MAIN_ROUTE } from '../../constants/auth.routing.constants';
import { VENDOR_MAIN_ROUTE } from '../../constants/vendor.routing.constants';

export type AppPortal = 'admin' | 'employee' | 'vendor';

function matchesRoutePrefix(url: string, route: string): boolean {
  const path = url.split('?')[0];
  const prefix = `/${route}`;
  return path === prefix || path.startsWith(`${prefix}/`);
}

export function isVendorPortalUrl(url: string): boolean {
  return matchesRoutePrefix(url, VENDOR_MAIN_ROUTE);
}

export function isAdminPortalUrl(url: string): boolean {
  return matchesRoutePrefix(url, ADMIN_MAIN_ROUTE);
}

export function isAuthUrl(url: string): boolean {
  return matchesRoutePrefix(url, AUTH_MAIN_ROUTE);
}

export function resolvePortal(url: string): AppPortal | null {
  if (isVendorPortalUrl(url)) {
    return 'vendor';
  }

  if (isAdminPortalUrl(url)) {
    return 'admin';
  }

  if (isAuthUrl(url)) {
    return null;
  }

  return 'employee';
}

export function shouldSuppressNotifications(url: string): boolean {
  return isVendorPortalUrl(url) || isAuthUrl(url);
}

export function resolveAppUrl(
  routerUrl: string,
  locationPathname = globalThis.location?.pathname ?? ''
): string {
  const routerPath = routerUrl.split('?')[0];
  if (routerPath && routerPath !== '/') {
    return routerUrl;
  }
  return locationPathname || routerUrl;
}
